import IconOk from "@/assets/icons/logo_ok";
import IconVk from "@/assets/icons/logo_vk";
import Logo from "@assets/images/logo_short.png"
import { FooterData } from "../types";

export const footerConfig: FooterData = {
  socialLinks: [
    {
      name: "Vk",
      url: "https://vk.com/games.destiny",
      icon: <IconVk />,
    },
    {
      name: "Ok",
      url: "https://ok.ru/group/54880962805763",
      icon: <IconOk />,
    },
  ],
  sections: [
    {
      title: "",
      links: [
        {
          name: "Политика конфиденциальности",
          url: "#",
        },
        {
          name: "Условия использования",
          url: "#",
        },
        {
          name: "Политика cookie",
          url: "#",
        },
      ],
    },
    {
      title: "",
      links: [
        {
          name: "Блог",
          url: "#",
        },
        {
          name: "Написать нам",
          url: "#",
        },
        {
          name: "Информация об обновлениях",
          url: "#",
        },
      ],
    },
    {
      title: "Партнеры",
      links: [
        {
          name: "Для разработчиков",
          url: "#",
        },
      ],
    },
  ],
  copyright: "© 2012—2025 Destiny Games. All rights reserved. ",
  logoUrl: Logo,
};
